module.exports = __webpack_public_path__ + "img/PHONE_CALL.98c4b0e9.svg";